export default __webpack_public_path__ + "static/media/gallery_13.ba2ecd90.jpg";